import { ApiRequestPayload, Callback, ExtraAction, apiCall, apiRequestDefaultPayload } from '..';
import { UserCrm } from '../../../../model/UserCrm';

export const findUserCrmByQuery = (
  apiQuery: Map<string, string>,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const urlPathParameters: string[] = [];
  apiQuery.forEach((value, key) => urlPathParameters.push(`${key}=${value}`));
  const apiPath = `/api/crm/users?${urlPathParameters.join('&')}`;
  console.log(`apiPath`, apiPath);
  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: apiPath,
    onSuccess: successActionName,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};

export const updateUserCrm = (
  user: UserCrm,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: `/api/crm/users/${user.id}`,
    onSuccess: successActionName,
    data: user,
    method: 'PUT',
    callbacks: callbacks,
    extraActions: extraActions,
  };
  return apiCall(requestPayload);
};

export const changeUserCrmPassword = (
  username: string,
  password: string,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: `/api/public/crm/users/${username}`,
    onSuccess: successActionName,
    data: { password },
    method: 'PATCH',
    callbacks: callbacks,
    extraActions: extraActions,
  };
  return apiCall(requestPayload);
};

export const deleteUserCrm = (
  userId: number,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: `/api/crm/users/${userId}`,
    onSuccess: successActionName,
    method: 'DELETE',
    callbacks: callbacks,
    extraActions: extraActions,
  };
  return apiCall(requestPayload);
};

export const createUserCrm = (
  user: UserCrm,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: `/api/crm/users`,
    onSuccess: successActionName,
    data: user,
    method: 'POST',
    callbacks: callbacks,
    extraActions: extraActions,
  };
  return apiCall(requestPayload);
};
